<div id="content" class="allcp-form map-content" ng-controller="CustomerMapController" ng-init="init()">
<div ng-include="'modules/company/menus/customer_menu.html'"></div>
<div class="row">
	<div id="customer_map" style="width:100% !important;"></div>
</div>
<div ng-include="'modules/company/settings/partials/delete.html'"></div>
<!-- Modal -->
<div class="modal right fade" id="importCustomerList" tabindex="-1" role="dialog" aria-labelledby="importCustomerListLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="importCustomerListLabel">Excelden Müşteri Listesi Aktar</h4>
      </div>
	  <form ng-submit="importCustomerList(excel)">
      <div class="modal-body">
		<div class="loading" ng-if="upload">
			<div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
		</div>
		<div class="row mb20">
			<div class="col-md-12">

				<div class="col-md-6">
					<i class="fa fa-file-excel-o" style="font-size:180px !important" aria-hidden="true"></i>
				</div>

				<div class="col-md-6">
					<h3> 
						<span style="border-radius: 50% !important;background: #7F828F;color: #fff;width: 30px;height: 30px;padding: 1px;display: inline-block;text-align: center;margin-right: 10px;font-size: 24px;">1</span>
						Örnek Dosya
					</h3>
					<a href="#" ng-click="donwloadSampleExcel()" class="btn btn-primary">Örnek Excel Dosyasını İndİr</a>
					<p>Bu dosyayı indirerek, verilerinizi bu dosya formatına getiriniz.</p>
				</div>

			</div>
			<div class="col-md-12"><hr ></div>			
			<div class="col-md-12">
				<h3> 
					<span style="border-radius: 50% !important;background: #7F828F;color: #fff;width: 30px;height: 30px;padding: 1px;display: inline-block;text-align: center;margin-right: 10px;font-size: 24px;">2</span>
					Dosya Seç
				</h3>
				<div class="allcp-form theme-primary">
					<p>Örnek dosya ile hazırladığınız, excel müşteri listesini seçiniz.</p>
					<input type="file" fileread="uploadme">
				</div>
			</div>
		</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">İptal</button>
        <button type="submit" class="btn btn-primary">Aktarmaya Başla</button>
      </div>
	  </form>
    </div>
  </div>
</div>

</div>

<style>
    html, body {
        height:100% !important;
    }
</style>
<script>
    $(document).ready(function(){
    var height = $(window).height() - 116;
    $('.map-content').css('height',height);
        $(window).resize(function(){
        var height = $(window).height() - 116;
        $('.map-content').css('height',height);
        });
    });
</script>